import { AxiosRequestConfig } from 'axios'
import { createAxiosRTQuery } from './createAxiosRTQuery'

export const createExternalExchangeRTQuery = (requestConfig?: Partial<AxiosRequestConfig>) =>
  createAxiosRTQuery('regular', {
    baseURL: 'https://converter.pointsone.com/api/',
    ...requestConfig,
  })
